import { z } from 'zod';

/**
 * Résumé IA d'un dossier — contrat réseau, écrit à la main.
 *
 * `summary` est nul quand le dossier clinique est trop mince pour qu'on appelle un modèle :
 * l'écran le dit dans la langue de l'interface. Sinon c'est le texte clinique, sans l'identité
 * que la fiche affiche déjà. `source` dit si ce texte vient du stock ou d'un appel neuf.
 */

export const patientAiSummarySources = ['cache', 'generated', 'empty'] as const;
export type PatientAiSummarySource = (typeof patientAiSummarySources)[number];

export const patientAiSummarySchema = z
  .object({
    summary: z.string().max(8000).nullable(),
    source: z.enum(patientAiSummarySources),
    generatedAt: z.iso.datetime().nullable(),
  })
  .strict();
export type PatientAiSummaryDto = z.infer<typeof patientAiSummarySchema>;
